import { isMockMode, postBlast, simulateDelay } from "../../api";

export interface UpdateNodeLibraryPermissionsRequest {
	id: string;
	emails: string[];
	isDeleted?: boolean;
	hasWriteAccess?: boolean;
}

export const updateNodeLibraryPermissions = ({
	id,
	emails,
	isDeleted = false,
	hasWriteAccess = false,
}: UpdateNodeLibraryPermissionsRequest) => {
	if (isMockMode()) {
		const testData = {
			success: true,
		};
		return simulateDelay(50, () => testData);
	}

	return postBlast(`nodelibrary/updatepermissions`, {
		id,
		emails,
		isDeleted,
		hasWriteAccess,
	});
};
